export default __webpack_public_path__ + "static/media/logout.dd8c9d3e.svg";